import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {GetExamsDistrictsParams} from 'domain/usecases/private/booking-flow/exams/get-exams-districts';
import {getExamsDistricts} from '../../services/getExamsDistricts';

export function useGetExamsDistrictsQuery(
	params: GetExamsDistrictsParams,
	enabled: boolean = true,
) {
	return useQuery({
		queryKey: [QUERY_KEYS.DISTRICTS_EXAMS, params],
		queryFn: ({signal}) => getExamsDistricts({signal, ...params}),
		enabled,
	});
}
